<template>
  <div class="company-profile-form-page page-content">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <el-button type="text"
                   icon="el-icon-back"
                   class="back-button"
                   @click.prevent="backToCompanyProfileList">
        </el-button>
        <h2 class="page-title">รายละเอียดข้อมูลบริษัทสำหรับรับชำระ</h2>
      </el-col>
    </el-row>
    <el-row class="detail-section">
      <el-row class="detail-row">
        <el-row>
          <el-col :span="24">
            <table id="company-profile-detail-table">
              <tr>
                <th colspan="2"><h3 class="section-title">ข้อมูลบริษัทสำหรับรับชำระ</h3></th>
              </tr>
              <tr>
                <th>ชื่อบริษัท</th>
                <td>{{ profileForm.name }}</td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2">
                  <h3 class="section-title">ที่อยู่บริษัท</h3>
                </th>
              </tr>
              <tr>
                <th>ใช้ที่อยู่เดียวกับรายละเอียดหลักของบริษัท</th>
                <td>{{ profileForm.use_company_address ? 'ใช่' : 'ไม่ใช่' }}</td>
              </tr>
              <tr>
                <th>ที่อยู่</th>
                <td>{{ profileForm.address.line_1 || '-' }}</td>
              </tr>
              <tr>
                <th>ตำบล/แขวง</th>
                <td>{{ profileForm.address.district || '-' }}</td>
              </tr>
              <tr>
                <th>อำเภอ/เขต</th>
                <td>{{ profileForm.address.city || '-' }}</td>
              </tr>
              <tr>
                <th>จังหวัด</th>
                <td>{{ profileForm.address.province || '-' }}</td>
              </tr>
              <tr>
                <th>รหัสไปรษณีย์</th>
                <td>{{ profileForm.address.postal_code || '-' }}</td>
              </tr>
              <tr>
                <th>โทรศัพท์</th>
                <td>{{ profileForm.address.tel || '-' }}</td>
              </tr>
              <tr>
                <th>โทรสาร</th>
                <td>{{ profileForm.address.fax || '-' }}</td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">Bill Payment</h3></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">Cross Bank Bill Payment</h3></th>
              </tr>
              <tr>
                <th>หมายเลขบัญชี</th>
                <td>{{ profileForm.bill_payment_account_no || '-' }}</td>
              </tr>
              <tr>
                <th>COMP CODE</th>
                <td>{{ profileForm.bill_payment_comp_code || '-' }}</td>
              </tr>
              <tr>
                <th>Biller ID</th>
                <td>{{ profileForm.bill_payment_biller_id || '-' }}</td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">ข้อมูลสำหรับบาร์โค้ดและ QR code</h3></th>
              </tr>
              <tr>
                <th>หมายเลขบัญชี</th>
                <td>
                  {{ profileForm.barcode_qrcode_account_no || '-' }}
                  {{ profileForm.barcode_qrcode_account_no_suffix }}
                </td>
              </tr>
              <tr>
                <th>Biller ID</th>
                <td>
                  {{ profileForm.barcode_qrcode_biller_id_tax_id || '-' }}
                  {{ profileForm.barcode_qrcode_biller_id_suffix }}
                </td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">Business Type</h3></th>
              </tr>
              <tr>
                <th>Business Type</th>
                <td>
                  {{ profileForm.business_type == 'B2C' ? 'B2C' : '' }}
                  {{ profileForm.business_type == 'B2B' ? 'ธุรกิจ B2B' : '' }}
                  {{ profileForm.business_type == 'EDU' ? 'สถานศึกษา' : '' }}
                  {{ profileForm.business_type == 'SPECIAL' ? `ธุรกิจพิเศษ สาขา${profileForm.business_type_special_industry}` : '' }}
                </td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">วิธีการชำระเงิน</h3></th>
              </tr>
              <tr>
                <th>วิธีการชำระเงิน</th>
                <td>
                  {{ profileForm.payment_type == 'CHEQUE_OR_CASH' ? 'เช็ค/เงินสด' : '' }}
                  {{ profileForm.payment_type == 'CASH_ONLY' ? 'เงินสดอย่างเดียว' : '' }}
                </td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">Charge Type</h3></th>
              </tr>
              <tr>
                <th>Charge Type</th>
                <td>
                  {{ profileForm.charge_payer ? 'Payer' : 'Biller' }}
                </td>
              </tr>
              <tr>
                <th>IB/IR</th>
                <td>
                  {{ profileForm.ir_br || '' }}
                </td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">Account Reference</h3></th>
              </tr>
              <tr>
                <th>ชื่อบัญชี</th>
                <td>
                  {{ profileForm.account_name || '-' }}
                </td>
              </tr>
              <tr>
                <th>Label (Ref. 1)</th>
                <td>
                  {{ profileForm.label_ref1 || '-' }}
                </td>
              </tr>
              <tr>
                <th>Label (Ref. 2)</th>
                <td>
                  {{ profileForm.label_ref2 || '-' }}
                </td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">ข้อมูลบัญชีธนาคารอื่นๆที่จะปรากฎบน Pay-in Slip</h3></th>
              </tr>

              <tr>
                <th>Admin ของบริษัทผู้ใช้งานสามารถเพิ่มข้อมูลด้วยตนเองได้</th>
                <td>
                  {{ profileForm.allow_other_banks ? 'เพิ่มได้' : 'เพิ่มไม่ได้' }}
                </td>
              </tr>
              <tr v-if="profileForm.allow_other_banks">
                <th>รายการข้อมูลบัญชีธนาคารอื่นๆ</th>
                <td>
                  <div>
                    <div class="other-bank-list" v-for="bankInfo in profileForm.other_banks">
                      <div class="other-bank-info">
                        <div class="other-bank-logo-holder">
                          <img :src="bankInfo.account_logo" v-if="bankInfo.account_logo">
                        </div>
                        <div class="other-bank-text-holder">
                          {{ bankInfo.account_name.trim() !== '' ? getOtherBankInfoSummaryText(bankInfo) : '-' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">การแจ้งเตือน</h3></th>
              </tr>
              <tr>
                <th>ข้อความแจ้งเตือน</th>
                <td>
                  {{ profileForm.notification_msg || '-' }}
                </td>
              </tr>

              <tr>
                <th colspan="2"><hr></th>
              </tr>
              <tr>
                <th colspan="2"><h3 class="section-title">ตัวเลือกในการพิมพ์</h3></th>
              </tr>
              <tr>
                <th>โลโก้บริษัท</th>
                <td>
                  <div class="logo-holder" v-if="profileForm.logo">
                    <img :src="profileForm.logo" class="logo" style="max-width:150px;"/>
                  </div>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
  /* eslint no-param-reassign: 0 */
  import { createMask } from 'imask';
  /**
   * Company Profile Detail view
   */
  const CompanyProfileDetailView = {
    name: 'company-profile-detail',
    props: ['companyId', 'profileId'],
    data() {
      return {
        isSubmitting: false,
        dayList: [],
        profileForm: {
          id: null,
          name: '',
          use_company_address: true,
          address: {
            line_1: '',
            district: '',
            city: '',
            province: '',
            postal_code: '',
            tel: '',
            fax: '',
          },
          use_bill_payment_comp_code: false,
          bill_payment_comp_code: '',
          use_bill_payment_account_no: false,
          bill_payment_account_no: '',
          use_bill_payment_biller_id: true,
          bill_payment_biller_id: '',
          barcode_qrcode_type: 'biller_id',
          barcode_qrcode_biller_id_tax_id: '',
          barcode_qrcode_biller_id_suffix: '',
          barcode_qrcode_account_no: '',
          barcode_qrcode_account_no_suffix: '',
          payment_type: 'CHEQUE_OR_CASH', // "CHEQUE_OR_CASH", "CASH_ONLY"
          charge_payer: false,
          ir_br: '',
          account_name: '',
          label_ref1: '',
          label_ref2: '',
          label_ref3: '',
          allow_other_banks: true,
          other_banks: [
            {
              account_name: 'ธนาคารกรุงเทพ',
              account_number: '000-0-12345-1',
              account_logo: 'https://res.cloudinary.com/hpfrx0s4s/image/upload/v1529001251/xlvi0rbddydqkqsyxaxe.png',
              comcode: '3748',
              service_fee: 'ค่าธรรมเนียม 15 บาททุกรายการ',
              service_code: '0838',
              branch_code: '0001',
            },
          ],
          notification_msg_type: 'CUSTOM', // DATE or CUSTOM
          notification_msg_date: '1',
          notification_msg_custom: '',
          notification_msg: '',
          logo: '',
          printing_option: 'COLOR', // "COLOR", "BLACK_AND_WHITE"
          business_type: 'B2C',
          business_type_special_industry: null,
        },
        mask: {
          compCode: {
            mask: /^\d{0,4}$/,
          },
          accountNo: {
            mask: '000-0-00000-0',
          },
          billerId: {
            /* mask: [
              { mask: '0000000000' },
              { mask: '0000000000000' },
            ], */
            mask: /^\d{0,15}$/,
          },
          postcode: {
            mask: '00000',
          },
          telMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
            { mask: '{0}00-000-0000' },
          ],
          faxMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
          ],
          ibirMask: {
            mask: /^\d+\/\d+$/,
          },
          qrBillerId: {
            mask: /^\d{0,13}$/,
          },
          suffix: {
            mask: '00',
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      company() {
        return this.$store.getters.currentCompany;
      },
      profile() {
        return this.$store.getters.currentCompanyProfile;
      },
    },
    methods: {
      backToCompanyProfileList() {
        const params = {
          companyId: this.companyId,
        };
        this.$router.push({ name: 'CompanyProfileList', params });
      },
      setupUpdateData() {
        Object.keys(this.profile).forEach((key) => {
          if (key === 'address') {
            // let isUseCompanyAddress = true;
            Object.keys(this.profile.address).forEach((addrKey) => {
              // check if the value for this profile & company are the same or not
              /* if (this.profile.address[addrKey] !== this.company.address[addrKey]) {
                isUseCompanyAddress = false;
              } */
              this.$set(this.profileForm.address, addrKey, this.profile.address[addrKey]);
            });
            // this.use_company_address = isUseCompanyAddress;
          } else if (key === 'notification_msg') {
            if (this.profile[key] === null) {
              this.$set(this.profileForm, key, '');
            } else {
              this.$set(this.profileForm, key, this.profile[key]);
            }
          } else {
            this.$set(this.profileForm, key, this.profile[key]);
          }
        });
        // update required control fields' value
        this.profileForm
          .use_bill_payment_comp_code = !!this.profileForm.bill_payment_comp_code;
        this.profileForm
          .use_bill_payment_account_no = !!this.profileForm.bill_payment_account_no;
        this.profileForm
          .use_bill_payment_biller_id = !!this.profileForm.bill_payment_biller_id;
        this.profileForm
          .barcode_qrcode_type = this.profileForm.barcode_qrcode_biller_id_tax_id ? 'biller_id' : 'account_no';
        this.profileForm.notification_msg_type = this.profileForm
          .notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 &&
        this.profileForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
        if (this.profileForm.notification_msg_type === 'DATE') {
          this.profileForm
            .notification_msg_date = this.profileForm.notification_msg
              .replace('กรุณาชำระภายในวันที่', '')
              .replace('ของทุกเดือน', '');
        } else {
          this.profileForm.notification_msg_custom = this.profileForm.notification_msg;
        }
        if (this.profileForm.business_type === '') {
          this.profileForm.business_type = 'B2C';
        }
        if (this.profileForm.business_type !== 'SPECIAL') {
          this.profileForm.business_type_special_industry = null;
        }
        this.updatePostCode();
        this.updateMaskAccountNo();
        this.updateMaskBillerId();
      },
      updatePostCode() {
        try {
          this.maskValue(this.profileForm.address, 'postal_code', this.mask.postcode);
        } catch (e) {
          console.error(e);
        }
      },
      updateMaskCompCode() {
        this.maskValue(this.profileForm, 'bill_payment_comp_code', this.mask.compCode);
      },
      updateMaskAccountNo() {
        this.maskValue(this.profileForm, 'bill_payment_account_no', this.mask.accountNo);
        this.maskValue(this.profileForm, 'barcode_qrcode_account_no', this.mask.accountNo);
      },
      updateMaskBillerId() {
        this.maskValue(this.profileForm, 'bill_payment_biller_id', this.mask.billerId);
        this.maskValue(this.profileForm, 'barcode_qrcode_biller_id_tax_id', this.mask.qrBillerId);
      },
      maskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          const resolvedValue = mask.resolve(val.toString());
          form[field] = resolvedValue;
        }
      },
      isBBLBank(accountName) {
        const testString = accountName.toLowerCase();
        const isBBL = testString.indexOf('bbl') !== -1 ||
          testString.indexOf('bangkok') !== -1 ||
          testString.indexOf('กรุงเทพ') !== -1;
        return isBBL;
      },
      getOtherBankInfoSummaryText(bankInfo) {
        let bankInfoText = `${bankInfo.account_name} A/C : ${bankInfo.account_number} / COMP CODE: ${bankInfo.comcode}`;
        if (this.isBBLBank(bankInfo.account_name)) {
          bankInfoText += ` / SERVICE CODE: ${bankInfo.service_code} / BR CODE: ${bankInfo.branch_code}`;
        }
        bankInfoText += ` / FEE : ${bankInfo.service_fee}`
        return bankInfoText;
      },
      clearUpdateData() {
        this.profileForm.id = null;
        this.profileForm.name = '';
        this.profileForm.use_company_address = true;
        this.profileForm.address.line_1 = '';
        this.profileForm.address.district = '';
        this.profileForm.address.city = '';
        this.profileForm.address.province = '';
        this.profileForm.address.postal_code = '';
        this.profileForm.address.tel = '';
        this.profileForm.address.fax = '';
        this.profileForm.use_bill_payment_comp_code = false;
        this.profileForm.bill_payment_comp_code = '';
        this.profileForm.use_bill_payment_account_no = false;
        this.profileForm.bill_payment_account_no = '';
        this.profileForm.use_bill_payment_biller_id = true;
        this.profileForm.bill_payment_biller_id = '';
        this.profileForm.barcode_qrcode_type = 'biller_id';
        this.profileForm.barcode_qrcode_biller_id_tax_id = '';
        this.profileForm.barcode_qrcode_biller_id_suffix = '';
        this.profileForm.barcode_qrcode_account_no = '';
        this.profileForm.barcode_qrcode_account_no_suffix = '';
        this.profileForm.payment_type = 'CHEQUE_OR_CASH';
        this.profileForm.charge_payer = false;
        this.profileForm.ir_br = '';
        this.profileForm.account_name = '';
        this.profileForm.label_ref1 = '';
        this.profileForm.label_ref2 = '';
        this.profileForm.label_ref3 = '';
        this.profileForm.allow_other_banks = false;
        this.profileForm.other_banks.splice(0);
        this.profileForm.notification_msg_type = 'CUSTOM';
        this.profileForm.notification_msg_date = '1';
        this.profileForm.notification_msg_custom = '';
        this.profileForm.notification_msg = '';
        this.profileForm.logo = '';
        this.profileForm.printing_option = 'COLOR';
      },
    },
    mounted() {
      // clear list
      this.dayList.splice(0);
      // populate day list
      for (let d = 1; d <= 31; d += 1) {
        this.dayList.push(d);
      }
      setTimeout(() => {
        if (typeof this.profile === 'undefined' || this.profile === null) {
          this.backToCompanyProfileList();
        }
      }, 1000);
      if (this.profile) {
        this.setupUpdateData();
      }
    },
    watch: {
      profile(newVal) {
        if (newVal) {
          this.setupUpdateData();
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
        vm.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', vm.profileId);
      });
    },
    beforeRouteLeave(to, from, next) {
      this.clearUpdateData();
      this.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', '');
      next();
    },
  };
  export default CompanyProfileDetailView;
</script>

<style lang="scss" scoped="true">
  #company-profile-detail-table {
    width: 100%;

    th, td {
      text-align: left;
      line-height: 1.5;
      padding: 5px 10px 10px;
      vertical-align: top;
    }
    th {
      width: 150px;
      text-align: right;
    }
    h3 {
      margin: 0;
      text-align: left;
    }
    .other-bank-list {
      .other-bank-info {
        clear: both;
        margin-bottom: 15px;
      }
      .other-bank-logo-holder {
        width: 40px;
        height: 40px;
        border: 1px solid #ccc;
        background: #efefef;
        display: inline-block;
        float: left;
        margin-right: 10px;

        img {
          max-width: 100%;
        }
      }
      .other-bank-text-holder {
        line-height: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/company-profile-detail.vue